'use client';

import { useState, useEffect } from 'react';

export const useIsMobile = (
  { width }: { width?: number } = { width: 768 },
): boolean => {
  // Initialize with SSR-safe value
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Debounce resize handler for better performance
    let timeoutId: NodeJS.Timeout;

    const checkIsMobile = () => {
      const mobile = window.innerWidth <= (width ?? 768);
      setIsMobile(mobile);
    };

    const debouncedCheck = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkIsMobile, 150);
    };

    // Initial check
    checkIsMobile();

    // Use passive listener for better scroll performance
    window.addEventListener('resize', debouncedCheck, { passive: true });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', debouncedCheck);
    };
  }, [width]);

  return isMobile;
};
